import { type UseQueryResult, useQuery } from 'react-query';
import { OptionAwardService } from '@wealthlane/api-services/wealthlane-award-service';
import { FeatureSetService } from '@wealthlane/api-services/wealthlane-identity-service';

const useGetFeatureSetOption = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const featureSetOption = useQuery(
    ['getFeatureSetOption'],
    async () => {
      return await handleRequest(FeatureSetService.getApiIdentityFeatureSetOptions());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return featureSetOption;
};

export default useGetFeatureSetOption;
